import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { Col, FormGroup, FormText, Label } from 'reactstrap'
import { FormBoxContext } from './FormBox'
import _ from 'common-tools/LodashHelper'
import styles from './FieldLayoutBox.less'
import LoadingOverlay from 'react-loading-overlay'

export const FieldLayoutSizes = {
  Full: { sm: 12, md: 12, lg: 12, xl: 12 },
  Half: { sm: 12, md: 6, lg: 6, xl: 6 },
  Third: { sm: 12, md: 4, lg: 4, xl: 4 },
  Quarter: { sm: 12, md: 3, lg: 3, xl: 3 },
  One: { sm: 12, md: 1, lg: 1, xl: 1 },
  Two: { sm: 12, md: 2, lg: 2, xl: 2 },
  Three: { sm: 12, md: 3, lg: 3, xl: 3 },
  Four: { sm: 12, md: 4, lg: 4, xl: 4 },
  Five: { sm: 12, md: 5, lg: 5, xl: 5 },
  Six: { sm: 12, md: 6, lg: 6, xl: 6 },
  Seven: { sm: 12, md: 7, lg: 7, xl: 7 },
  Eight: { sm: 12, md: 8, lg: 8, xl: 8 },
  Nine: { sm: 12, md: 9, lg: 9, xl: 9 },
  Ten: { sm: 12, md: 10, lg: 10, xl: 10 },
  Eleven: { sm: 12, md: 11, lg: 11, xl: 11 },
  Middle: { sm: { size: 12, offset: 0 }, md: { size: 10, offset: 2 }, lg: { size: 6, offset: 3 }, xl: { size: 4, offset: 4 } }
}

export class FieldLayoutBox extends React.Component {
  static contextType = FormBoxContext
  static propTypes = {
    WrappedCtrl: pt.shape({
      meta: pt.object,
      helpText: pt.string,
      label: pt.string,
      caption: pt.string,
      readonly: pt.bool,
      input: pt.shape({
        value: pt.any,
        onChange: pt.func,
        onBlur: pt.func,
        name: pt.string.isRequired,
        onFocus: pt.func
      })
    }),
    formGroupProps: pt.object,
    children: pt.func.isRequired,
    hide: pt.bool.isRequired
  }

  static defaultProps = {
    hide: false,
    formGroupProps: null
  }

  render () {
    const { meta, label, caption, layout, hide, readonly, input: { value, onChange, onBlur, name, onFocus }, placeHolder, children, isCheckBox, formGroupProps } = this.props
    const { loading, readonly: contextReadonly } = this.context

    if (hide) {
      return null
    }

    let showError = (meta.touched === true || meta.submitFailed === true) && meta.invalid === true
    let errorMessage = showError ? meta.error || '' : ''

    if (_.isArray(errorMessage) === true) {
      showError = false
      console.log(errorMessage)
    }

    const ctrl = <LoadingOverlay
      active={loading}
      classNamePrefix='fieldloading_'
      styles={{
        wrapper: {},
        overlay: { opacity: '.5' },
        content: {},
        spinner: {}
      }}
    >{children({
        showError,
        value,
        onChange,
        onBlur,
        name,
        onFocus,
        placeHolder,
        loading,
        readonly: readonly || contextReadonly || false
      })}
    </LoadingOverlay>

    const fieldLayout = (
      <FormGroup {...formGroupProps} check={isCheckBox}>
        {label
          ? <Label check={isCheckBox}>{
            isCheckBox
              ? <React.Fragment>{ctrl}{' '}{label}</React.Fragment>
              : label
          }</Label>
          : null
        }
        {
          isCheckBox
            ? null
            : ctrl
        }
        {showError
          ? <span className={styles.errorMessage}>{errorMessage}</span>
          : null
        }
        {caption
          ? <FormText>{caption}</FormText>
          : null
        }
      </FormGroup>
    )

    if (layout) {
      let colStyle = isCheckBox
        ? {
          display: 'flex',
          alignItems: 'center'
        }
        : {}

      let colLayout = { ...layout }

      if (_.isNumber(layout.all)) {
        colLayout = { sm: layout.all, md: layout.all, lg: layout.all, xl: layout.all }
      }

      return (<Col {...colLayout} style={colStyle}>
        {fieldLayout}
      </Col>)
    } else {
      return fieldLayout
    }
  }
}
